import { render, staticRenderFns } from "./TheHeaderMobile.vue?vue&type=template&id=0bef34ba"
import script from "./TheHeaderMobile.vue?vue&type=script&lang=js"
export * from "./TheHeaderMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports